import { AlertEventsState } from "@idw-types/state/alert-events-state";
import { TimeRangeTypes } from "@enums/time-range-types";
import { getTimeRange } from "@utils/date-util";
import { AlertEventsActionTypes, AlertEventsActions } from "../actions/alert-events-actions";

export const initialAlertEventsState: AlertEventsState = {
    referenceData: {
        isLoading: false,
        alerts: null,
        assertions: null,
        attributeTypes: null,
        companies: null,
        policies: null,
        rpServices: null,
        workflows: null
    },
    searchFilters: {
        alertIds: [],
        companyIds: [],
        startDate: getTimeRange(TimeRangeTypes.TODAY).startDate,
        endDate: getTimeRange(TimeRangeTypes.TODAY).endDate,
        timeRangeType: TimeRangeTypes.TODAY
    },
    searchResults: {
        searchDate: null,
        isLoading: false,
        alertEvents: null
    }
};

export const alertEventsReducer = (
    state: AlertEventsState = initialAlertEventsState,
    action: AlertEventsActions
): AlertEventsState => {
    switch (action.type) {
        // Alert Events Reference Data
        case AlertEventsActionTypes.SET_ALERT_EVENTS_REFERENCE_DATA_LOADING:
            return {
                ...state,
                referenceData: {
                    ...(action.payload.isLoading
                        ? { ...initialAlertEventsState.referenceData }
                        : { ...state.referenceData }
                    ),
                    isLoading: action.payload.isLoading
                }
            };
        case AlertEventsActionTypes.SET_ALERT_EVENTS_REFERENCE_DATA:
            return {
                ...state,
                referenceData: {
                    ...action.payload.referenceData,
                    isLoading: false
                }
            };
        // Alert Events Search
        case AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...(action.payload.isLoading
                        ? { ...initialAlertEventsState.searchResults }
                        : { ...state.searchResults }),
                    isLoading: action.payload.isLoading
                }
            };
        case AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: {
                    isLoading: false,
                    alertEvents: action.payload.alertEvents,
                    searchDate: new Date()
                }
            };
        default:
            return state;
    }
};